import { createClient } from '@supabase/supabase-js';

// Accessing the environment variables in React starts with REACT_APP_
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY || 'public-anon-key-placeholder';

export const supabase = createClient(supabaseUrl, supabaseKey);
